import React from "react";

import "./Footer.css";

export default function Footer() {
    return (
        <footer className="Footer">
            <small>
                <a
                    href="https://github.com/dashacherednichenko/react-dictionary"
                    target="_blank"
                >
                    Open-source code
                </a>
                , by Dariia Piven
            </small>
        </footer>
    );
}
